<template>
  <div ref="information" :style="{height:height,width:width}"/>
</template>

<script>

export default {
  name: 'LineChart',
  isAutoComponent: true,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    color: {
      type: String,
      default: '#050505'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs['information'])
      this.setOptions(this.chartData)

      window.addEventListener('resize', () => {
        this.chart && this.chart.resize()
      })
    },
    setOptions(data) {
      const lengthData = []
      const seriesData = []
      if (data.line !== undefined) {
        for (let i = 0; i < data.line.length; i++) {
          lengthData.push(data.line[i].name)
          seriesData.push({
            type: 'line',
            name: data.line[i].name,
            label: {
              show: data.line[i].label === undefined ? true : data.line[i].label,
              position: 'top'
            },
            data: data.line[i].data,
            lineStyle: {
              width: 3 // 设置线条宽度为2像素
            },
            itemStyle: {
              color: data.line[i].color
            },
            areaStyle: {
              color: data.line[i].areaColor
            }
          })
        }
      }
      this.chart.setOption({
        title: [
          {
            text: this.title,
            x: 'left',
            textStyle: {
              color: '#050505',
              width: 100,
              fontSize: 20,
              lineHeight: 14,
              fontWeight: '700',
              overflow: 'breakAll',
              fontFamily: 'MiSans-Bold'
            }
          }
        ],
        xAxis: {
          splitLine: { show: false },
          data: data.xAxisData,
          type: 'category',
          axisLabel: {
            color: '#050505',
            fontSize: '8',
            rotate: 60
          }
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 0,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            color: '#050505'
          },
          axisLabel: {
            color: '#050505'
          }
        },
        legend: {
          data: lengthData,
          left: '15%',
          textStyle: {
            color: '#050505'
          }
        },
        series: seriesData
      })
    }
  }
}
</script>
